<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import MailingListsView from "@/components/crm/mailingListsView.vue";

/**
 * Starter component
 */
export default {
    page: {
        title: "Mailing Lists",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, MailingListsView },
    data() {
        return {
            title: "Mailing Lists",
            items: [
                {
                    text: "Utility",
                    active: true,
                },
            ],
        };
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <MailingListsView />
    </Layout>
</template>
